module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ftxq"
  }, [_c('topNav', {
    attrs: {
      "title": _vm.$t('fangTXQ_title'),
      "url": "/fangT",
      "replace": "true"
    }
  }), _vm._v(" "), (_vm.orderInfo.fMasterDto) ? _c('div', {
    staticClass: "warp"
  }, [_c('div', {
    staticClass: "orderSta clearfix"
  }, [_c('div', {
    staticClass: "Num"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_rsvNo')) + ":\n        "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.fMasterDto.masterBase.rsvNo))]), _vm._v(" "), (_vm.orderInfo.fMasterDto.masterBase.rsvClass == 'D' || _vm.orderInfo.fMasterDto.masterBase.rsvClass == 'G') ? _c('mt-badge', {
    staticStyle: {
      "height": "14px",
      "line-height": "14px"
    },
    attrs: {
      "type": "success",
      "size": "small"
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.fMasterDto.masterBase.rsvClass == 'D' ? _vm.$t('fangTXQ_orderDisD') :
    _vm.$t('fangTXQ_orderDisG')) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "sta"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_sta')) + ":\n        "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.fMasterDto.masterBase.sta))])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList"
  }, [_c('div', {
    staticClass: "info"
  }, [(_vm.hasChangeRoom) ? _c('div', {
    staticClass: "hasChangeIcon"
  }, [_vm._v("换房")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "infoTop"
  }, [_c('i', {
    staticClass: "iconfont icon-changfangxingbiaoqian"
  }), _vm._v(" "), _vm._v("\n          " + _vm._s(_vm.$t('fangTXQ_baseInfo')) + "\n        ")]), _vm._v(" "), ((_vm.orderInfo.fMasterDto.masterBase.sta == 'R' || _vm.orderInfo.fMasterDto.masterBase.sta == 'I') && _vm.$hasPermission('mh!recpt!edit', _vm.orderInfo.rights.indexOf('recept!fit!ci') >= 0)) ? _c('div', {
    staticClass: "spe-addGuest",
    on: {
      "click": _vm.addGuest
    }
  }, [_c('i', {
    staticClass: "iconfont icon-jia"
  })]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "infoContent twocol"
  }, [_c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_name')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.fMasterDto.masterGuest.name))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_mobile')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_c('a', {
    attrs: {
      "href": "tel:" + _vm.orderInfo.fMasterDto.masterGuest.mobile
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.fMasterDto.masterGuest.mobile))])])]), _vm._v(" "), (_vm.orderInfo.fMasterDto.masterGuest.name2) ? _c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_name2')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.fMasterDto.masterGuest.name2))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.fMasterDto.masterGuest.firstName) ? _c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_firstName')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.fMasterDto.masterGuest.firstName) + " / " + _vm._s(_vm.orderInfo.fMasterDto.masterGuest.lastName))])]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.openChangeRoomTypeModal
    }
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_rmtype')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v("\n              " + _vm._s(_vm.getRmType(_vm.orderInfo.fMasterDto.masterBase.rmtype)))]), _vm._v(" "), (_vm.isJingJiang && !_vm.isThefClient) ? _c('span', {
    staticClass: "iconfont icon-xia2",
    staticStyle: {
      "position": "relative",
      "top": "2px"
    }
  }) : _vm._e()]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.openChangeRoomModal
    }
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_rmno')) + ":\n            "), _c('span', {
    staticClass: "infoVal",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.fMasterDto.masterBase.rmno))]), _vm._v(" "), _c('span', {
    staticClass: "iconfont icon-xia2",
    staticStyle: {
      "position": "relative",
      "top": "2px"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_arr')) + ":\n            "), _vm._v(" "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.fMasterDto.masterBase.arr))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_dep')) + ":\n            "), _vm._v(" "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.fMasterDto.masterBase.dep))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('fangTXQ_memberNo')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.fMasterDto.masterBase.memberNo))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_idCode')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.fMasterDto.masterGuest.idCode))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_idNo')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.fMasterDto.masterGuest.idNo) + "\n\n               "), (_vm.isJingJiang && _vm.$hasPermission('mh!recpt!edit', true)) ? _c('i', {
    staticClass: "iconfont icon-credentials_icon",
    staticStyle: {
      "margin-left": "0.5rem",
      "color": "#999",
      "margin-top": "0.1rem"
    },
    on: {
      "click": _vm.getJingJiangToken
    }
  }) : [(_vm.sfzR && _vm.$hasPermission('mh!recpt!edit', _vm.orderInfo.rights.indexOf('recept!fit!ci') >= 0)) ? _c('i', {
    staticClass: "iconfont icon-saoma",
    staticStyle: {
      "margin-left": "0.5rem",
      "color": "#999"
    },
    on: {
      "click": function($event) {
        return _vm.sfzRe(_vm.orderInfo.fMasterDto)
      }
    }
  }) : _vm._e()]], 2)]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_companyName')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.fMasterDto.masterBase.companyName))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_agentName')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.fMasterDto.masterBase.agentName))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_sourceName')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.fMasterDto.masterBase.sourceName))])]), _vm._v(" "), (_vm.orderInfo.fMasterDto.masterGuest.timesIn) ? _c('li', {}, [_vm._v(_vm._s(_vm.$t('fangTXQ_timesIn')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.fMasterDto.masterGuest.timesIn))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.pmsTimesIn) ? _c('li', {}, [_vm._v(_vm._s(_vm.$t('fangTXQ_pmsTimesIn')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.pmsTimesIn))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticStyle: {
      "clear": "both"
    }
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_ratecode')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.fMasterDto.masterBase.ratecode))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('fangTXQ_realRate')) + ":\n            "), _c('span', {
    staticClass: "infoVal",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("￥" + _vm._s(_vm.orderInfo.fMasterDto.masterBase.realRate) + "\n              "), (_vm.orderInfo.fMasterDto.masterBase.isSecretRate == 'T') ? _c('span', [_vm._v("保密")]) : _vm._e()]), _vm._v(" "), _c('i', {
    staticClass: "mintui mintui-more",
    on: {
      "click": _vm.getEveryDateRate
    }
  })]), _vm._v(" "), (_vm.fangTXQuseSign) ? _c('li', {
    staticClass: "p100",
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_vm._v("电子签名:\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_c('signModal', {
    attrs: {
      "masterId": _vm.orderInfo.fMasterDto.masterBase.rsvNo
    }
  })], 1)]) : _vm._e()])]), _vm._v(" "), _c('marketInfo', {
    attrs: {
      "masterBase": _vm.orderInfo.fMasterDto.masterBase
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "infoTop"
  }, [_c('i', {
    staticClass: "iconfont icon-changfangxingbiaoqian"
  }), _vm._v("\n          " + _vm._s(_vm.$t('fangTXQ_other')) + "\n        ")]), _vm._v(" "), _c('ul', {
    staticClass: "infoContent"
  }, [_c('li', {
    staticClass: "ha"
  }, [_vm._v(" " + _vm._s(_vm.$t('fangTXQ_amenities')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.fMasterDto.masterBase.amenities))])]), _vm._v(" "), _c('li', {
    staticClass: "ha"
  }, [_vm._v(" " + _vm._s(_vm.$t('fangTXQ_specials')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.fMasterDto.masterBase.specials))])]), _vm._v(" "), _c('li', {
    staticClass: "ha"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_remark')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.fMasterDto.masterBase.remark) + "\n              "), (_vm.$hasPermission('mh!resrv!cmme!up', _vm.orderInfo.rights.indexOf('resrv!fit!edit') >= 0)) ? _c('i', {
    staticClass: "iconfont icon-xiugai",
    on: {
      "click": _vm.updateRemark
    }
  }) : _vm._e()])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('fangTXQ_createUser')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.fMasterDto.masterBase.createUser))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('fangTXQ_createDatetime')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.fMasterDto.masterBase.createDatetime))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('fangTXQ_modifyUser')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.fMasterDto.masterBase.modifyUser))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('fangTXQ_modifyDatetime')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.fMasterDto.masterBase.modifyDatetime))])])])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "infoTop"
  }, [_c('span', [_c('i', {
    staticClass: "iconfont icon-changfangxingbiaoqian"
  }), _vm._v(" "), _vm._v("\n            " + _vm._s(_vm.$t('fangTXQ_live_with')) + "\n          ")]), _vm._v(" "), ((_vm.orderInfo.fMasterDto.masterBase.sta == 'I' || _vm.orderInfo.fMasterDto.masterBase.sta == 'R') && _vm.showPayBtn && _vm.$hasPermission('mh!recept!add', true)) ? _c('span', {
    staticClass: "addGuest",
    on: {
      "click": _vm.goAddLiveWith
    }
  }, [_c('i', {
    staticClass: "iconfont icon-jia"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "infoContent",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('ul', {
    staticClass: "lf"
  }, [_vm._l((_vm.orderInfo.fMasterDto.masterLiveList), function(val) {
    return _c('li', {
      key: val.masterBase.id,
      on: {
        "click": function($event) {
          return _vm.goLinkRoom(val.masterBase.id)
        }
      }
    }, [(val.masterGuest.name && (val.masterBase.sta == 'I' || val.masterBase.sta == 'R' || val.masterBase.sta == 'O')) ? [_vm._v("\n                " + _vm._s(val.masterBase.rmno) + " - " + _vm._s(val.masterGuest.name) + " "), _c('b', [_vm._v(_vm._s(val.masterBase.sta))])] : _vm._e()], 2)
  }), _vm._v(" "), (_vm.orderInfo.fMasterDto.masterLiveList.length == 0) ? _c('li', {
    staticStyle: {
      "color": "#ccc"
    }
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_none')) + "\n            ")]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "infoTop"
  }, [_c('i', {
    staticClass: "iconfont icon-changfangxingbiaoqian"
  }), _vm._v(" "), _vm._v("\n          " + _vm._s(_vm.$t('fangTXQ_al_room')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "infoContent",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('ul', {
    staticClass: "lf"
  }, [_vm._l((_vm.orderInfo.masterLinkListNew), function(val) {
    return _c('li', {
      key: val.id,
      on: {
        "click": function($event) {
          return _vm.goLinkRoom(val.id)
        }
      }
    }, [_vm._v("\n              " + _vm._s(val.rmno) + " - " + _vm._s(val.name) + " "), _c('b', [_vm._v(_vm._s(val.sta))])])
  }), _vm._v(" "), (_vm.orderInfo.masterLinkListNew.length == 0) ? _c('li', {
    staticStyle: {
      "color": "#ccc"
    }
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_none')) + "\n            ")]) : _vm._e()], 2)])])], 1), _vm._v(" "), _c('bill', {
    attrs: {
      "orderInfo": _vm.orderInfo
    },
    on: {
      "goInsertBill": function($event) {
        return _vm.doCheckShift('goInsertBill')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btnBottom "
  }, [(_vm.orderInfo.fMasterDto.masterBase.sta == 'R') ? _c('div', {
    staticClass: "staI "
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$hasPermission('mh!resrv!cancel', _vm.orderInfo.rights.indexOf('recept!fit!ci') >= 0)),
      expression: "$hasPermission('mh!resrv!cancel', orderInfo.rights.indexOf('recept!fit!ci') >= 0)"
    }],
    staticClass: "btn",
    on: {
      "click": _vm.cancelOrder
    }
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_cancelOrder')) + "\n        ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$hasPermission('mh!resrv!checkin', _vm.orderInfo.rights.indexOf('recept!fit!ci') >= 0)),
      expression: "$hasPermission('mh!resrv!checkin', orderInfo.rights.indexOf('recept!fit!ci') >= 0)"
    }],
    staticClass: "btn",
    on: {
      "click": _vm.checkIn
    }
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_checkIn')) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.fMasterDto.masterBase.sta == 'I') ? _c('div', {
    staticClass: "staR l_o_btm"
  }, [(_vm.$hasPermission('mh!accnt!req', _vm.orderInfo.rights.indexOf('act!posting') >= 0)) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.doCheckShift('addReceive1')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('fangTXQ_addReceive1')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.$hasPermission('mh!accnt!req', _vm.orderInfo.rights.indexOf('act!posting') >= 0)) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.doCheckShift('addReceive0')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('fangTXQ_addReceive0')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.$hasPermission('mh!rec!suspend', _vm.orderInfo.rights.indexOf('act!suspend') >= 0)) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.doCheckShift('keepDebts')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('fangTXQ_keepDebts')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.$hasPermission('mh!rec!checkout', _vm.orderInfo.rights.indexOf('act!checkout') >= 0)) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.doCheckShift('goIncomeCheckout')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('fangTXQ_checkOut')) + "\n        ")]) : _vm._e()]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.orderInfo.rights && _vm.orderInfo.fMasterDto.masterBase.sta == 'I') ? _c('mt-palette-button', {
    ref: "target_1",
    staticClass: "pb",
    attrs: {
      "content": "+",
      "direction": "lt",
      "radius": 80,
      "mainButtonStyle": "color:#fff;background-color:#f6a624;"
    }
  }, [(_vm.isJingJiang) ? [(_vm.$hasPermission('mh!scan!pay', _vm.orderInfo.rights.indexOf('act!posting') >= 0)) ? _c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    on: {
      "click": function($event) {
        return _vm.doCheckShift('goScanPay')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont iconfont icon-saoma"
  })]) : _vm._e(), _vm._v(" "), (_vm.$hasPermission('mh!resrv!pay', _vm.orderInfo.rights.indexOf('act!posting') >= 0)) ? _c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    on: {
      "click": function($event) {
        return _vm.doCheckShift('goIncomeAccount')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-JZQK"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    on: {
      "click": _vm.openJingJiangModal
    }
  }, [_c('i', {
    staticClass: "iconfont icon-qiapian"
  })]), _vm._v(" "), _c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    on: {
      "click": _vm.openPrintSelectModal
    }
  }, [_c('i', {
    staticClass: "iconfont icon-dayin"
  })]), _vm._v(" "), (_vm.$hasPermission('mh!recept!exten', _vm.orderInfo.rights.indexOf('recept!delay') >= 0)) ? _c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    on: {
      "click": _vm.showDelay
    }
  }, [_c('i', {
    staticClass: "iconfont icon-xuzhu"
  })]) : _vm._e()] : [(_vm.useQrcodePay) ? _c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    on: {
      "click": _vm.showQrcodeModal
    }
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  })]) : _vm._e(), _vm._v(" "), (_vm.$hasPermission('mh!scan!pay', _vm.orderInfo.rights.indexOf('act!posting') >= 0) && _vm.showPayBtn) ? _c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    on: {
      "click": function($event) {
        return _vm.doCheckShift('goScanPay')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont iconfont icon-saoma"
  })]) : _vm._e(), _vm._v(" "), (_vm.$hasPermission('mh!resrv!pay', _vm.orderInfo.rights.indexOf('act!posting') >= 0)) ? _c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    on: {
      "click": function($event) {
        return _vm.doCheckShift('goIncomeAccount')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-JZQK"
  })]) : _vm._e(), _vm._v(" "), (_vm.$hasPermission('mh!recept!exten', _vm.orderInfo.rights.indexOf('recept!delay') >= 0)) ? _c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    on: {
      "click": _vm.showDelay
    }
  }, [_c('i', {
    staticClass: "iconfont icon-xuzhu"
  })]) : _vm._e()]], 2) : (_vm.isJingJiang) ? _c('mt-palette-button', {
    ref: "target_1",
    staticClass: "pb",
    attrs: {
      "content": "+",
      "direction": "lt",
      "radius": 80,
      "mainButtonStyle": "color:#fff;background-color:#f6a624;"
    }
  }, [_c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    on: {
      "click": _vm.openPrintSelectModal
    }
  }, [_c('i', {
    staticClass: "iconfont icon-dayin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    staticStyle: {
      "display": "none"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-dayin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    staticStyle: {
      "display": "none"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-dayin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    staticStyle: {
      "display": "none"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-dayin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    staticStyle: {
      "display": "none"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-dayin"
  })])]) : _vm._e(), _vm._v(" "), _c('delayIn', {
    ref: "delay",
    on: {
      "success": _vm.getrmInfo
    }
  }), _vm._v(" "), _c('updateRemark', {
    ref: "upRemark",
    on: {
      "success": _vm.getrmInfo
    }
  }), _vm._v(" "), _c('selectShift', {
    ref: "selectShiftRef",
    on: {
      "success": _vm.setShift
    }
  }), _vm._v(" "), _c('jingJiangModal', {
    ref: "jingJiang",
    on: {
      "success": _vm.closeJingJiangModal
    }
  }), _vm._v(" "), (_vm.popupEvalDay && (_vm.isJingJiang && !_vm.isThefClient)) ? _c('div', {
    staticStyle: {
      "z-index": "3002",
      "height": "44px",
      "line-height": "44px",
      "position": "fixed",
      "bottom": "0",
      "width": "100%",
      "background": "#fff",
      "text-align": "center",
      "border-top": "1px solid #eaeaea"
    },
    on: {
      "click": _vm.openEditPriceModal
    }
  }, [_vm._v("\n    修改房价\n  ")]) : _vm._e(), _vm._v(" "), _c('mt-popup', {
    staticClass: "everyDatePop",
    attrs: {
      "position": "bottom",
      "modal": true
    },
    model: {
      value: (_vm.popupEvalDay),
      callback: function($$v) {
        _vm.popupEvalDay = $$v
      },
      expression: "popupEvalDay"
    }
  }, [(_vm.isJingJiang) ? _c('table', {
    staticClass: "checkList",
    staticStyle: {
      "border-collapse": "collapse"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_date')))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_rate')))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_rmnum')))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("优惠理由")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('fangTXQ_total')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.sumRate(_vm.dateRate)))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((_vm.dateRate), function(item) {
    return _c('tr', {
      key: item.rsv_date
    }, [_c('td', [_vm._v(_vm._s(_vm._f("dateF")(item.rsv_date)))]), _vm._v(" "), _c('td', [_c('small', [_vm._v("￥")]), _vm._v("\n          " + _vm._s(item.realShareRate) + "\n        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.rmnum))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getReasonDescript(item.dscResaon)))])])
  })], 2) : _c('table', {
    staticClass: "checkList",
    staticStyle: {
      "border-collapse": "collapse"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "40%"
    }
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_date')))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_rate')))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_rmnum')))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('fangTXQ_total')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.sumRate(_vm.dateRate)))]), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((_vm.dateRate), function(item) {
    return _c('tr', {
      key: item.rsv_date
    }, [_c('td', [_vm._v(_vm._s(_vm._f("dateF")(item.rsv_date)))]), _vm._v(" "), _c('td', [_c('small', [_vm._v("￥")]), _vm._v("\n          " + _vm._s(item.realShareRate) + "\n        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.rmnum))])])
  })], 2)]), _vm._v(" "), (_vm.updateGuest) ? _c('mt-popup', {
    staticClass: "guestInfo",
    attrs: {
      "popup-transition": "popup-fade"
    },
    model: {
      value: (_vm.guestPopVisible),
      callback: function($$v) {
        _vm.guestPopVisible = $$v
      },
      expression: "guestPopVisible"
    }
  }, [_c('h2', [_vm._v(" " + _vm._s(_vm.$t('orderDetail_guest_info')))]), _vm._v(" "), _c('div', {
    staticClass: "guestSwiper"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('fangTXQ_rmno')) + "：\n        "), _c('span', {
    staticClass: "formRoomNum"
  }, [_vm._v(" " + _vm._s(_vm.updateGuest.masterBase.rmno))])]), _vm._v(" "), _c('div', {
    staticClass: "infoToWrite"
  }, [_c('mt-field', {
    attrs: {
      "label": _vm.$t('fangTXQ_name'),
      "placeholder": _vm.$t('orderDetail_guest_name_placeholder')
    },
    model: {
      value: (_vm.updateGuest.masterGuest.name),
      callback: function($$v) {
        _vm.$set(_vm.updateGuest.masterGuest, "name", $$v)
      },
      expression: "updateGuest.masterGuest.name"
    }
  }), _vm._v(" "), _c('mt-field', {
    attrs: {
      "label": _vm.$t('fangTXQ_idNo'),
      "placeholder": _vm.$t('fangTXQ_idNo_placeholder')
    },
    model: {
      value: (_vm.updateGuest.masterGuest.idNo),
      callback: function($$v) {
        _vm.$set(_vm.updateGuest.masterGuest, "idNo", $$v)
      },
      expression: "updateGuest.masterGuest.idNo"
    }
  }), _vm._v(" "), _c('mt-field', {
    attrs: {
      "label": _vm.$t('orderDetail_mobile'),
      "placeholder": _vm.$t('orderDetail_mobile_placeholder'),
      "type": "number"
    },
    model: {
      value: (_vm.updateGuest.masterGuest.mobile),
      callback: function($$v) {
        _vm.$set(_vm.updateGuest.masterGuest, "mobile", $$v)
      },
      expression: "updateGuest.masterGuest.mobile"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('div', {
    staticClass: "unSure",
    on: {
      "click": _vm.cancleGuestPop
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "sure",
    on: {
      "click": _vm.changGuest
    }
  }, [_vm._v(_vm._s(_vm.$t('determine')) + "\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.doorCardModalShow) ? _c('div', {
    staticClass: "door-card-modal"
  }, [_c('div', {
    staticClass: "door-card-container"
  }, [_c('div', {
    staticClass: "door-card-title"
  }, [_vm._v(_vm._s(_vm.$t('jj_door_card_info')))]), _vm._v(" "), _c('div', {
    staticClass: "door-card-info"
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('div', {
    staticClass: "info-item-label"
  }, [_vm._v(_vm._s(_vm.$t('jj_room_no')) + "：")]), _vm._v(" "), _c('div', {
    staticClass: "info-item-content"
  }, [_vm._v(_vm._s(_vm.ResponseParameters.roomNo))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('div', {
    staticClass: "info-item-label"
  }, [_vm._v(_vm._s(_vm.$t('jj_beginTime')) + "：")]), _vm._v(" "), _c('div', {
    staticClass: "info-item-content"
  }, [_vm._v(_vm._s(_vm.ResponseParameters.beginTime))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('div', {
    staticClass: "info-item-label"
  }, [_vm._v(_vm._s(_vm.$t('jj_endTime')) + "：")]), _vm._v(" "), _c('div', {
    staticClass: "info-item-content"
  }, [_vm._v(_vm._s(_vm.ResponseParameters.endTime))])])]), _vm._v(" "), _c('div', {
    staticClass: "door-card-bottom"
  }, [_c('div', {
    staticClass: "door-btns",
    on: {
      "click": _vm.closeDoorCardModal
    }
  }, [_vm._v(_vm._s(_vm.$t('determine')) + "\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.printSelectModalShow) ? _c('div', {
    staticClass: "print-select-modal"
  }, [_c('div', {
    staticClass: "door-card-container"
  }, [_c('div', {
    staticClass: "door-card-title"
  }, [_vm._v("打印")]), _vm._v(" "), _c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "spe-row"
  }, [_c('div', {
    staticClass: "btn-default",
    on: {
      "click": function($event) {
        return _vm.getListBillSceneLink("RECEPT")
      }
    }
  }, [_vm._v("打印登记单\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "btn-default",
    on: {
      "click": _vm.getListDeposit
    }
  }, [_vm._v("打印定金单\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "spe-row"
  }, [_c('div', {
    staticClass: "btn-default",
    on: {
      "click": function($event) {
        return _vm.getListBillSceneLink("FO_BILL")
      }
    }
  }, [_vm._v("打印账单\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "door-card-bottom"
  }, [_c('div', {
    staticClass: "door-btns",
    on: {
      "click": _vm.closePrintSelectModal
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')) + "\n        ")])])])]) : _vm._e(), _vm._v(" "), _c('mt-popup', {
    staticClass: "selectShift select-wrap",
    attrs: {
      "popup-transition": "popup-fade"
    },
    model: {
      value: (_vm.showPop),
      callback: function($$v) {
        _vm.showPop = $$v
      },
      expression: "showPop"
    }
  }, [_c('h2', [_vm._v("押金记录")]), _vm._v(" "), _c('div', {
    staticClass: "select-list-wrap"
  }, [_c('mt-radio', {
    attrs: {
      "options": _vm.listDeposit
    },
    model: {
      value: (_vm.currentCode),
      callback: function($$v) {
        _vm.currentCode = $$v
      },
      expression: "currentCode"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('div', {
    staticClass: "unSure",
    on: {
      "click": function($event) {
        _vm.showPop = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "sure",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('determine')) + "\n      ")])])]), _vm._v(" "), _c('mt-popup', {
    staticClass: "selectShift select-wrap",
    attrs: {
      "popup-transition": "popup-fade"
    },
    model: {
      value: (_vm.showPop2),
      callback: function($$v) {
        _vm.showPop2 = $$v
      },
      expression: "showPop2"
    }
  }, [_c('h2', [_vm._v("选择场景")]), _vm._v(" "), _c('div', {
    staticClass: "select-list-wrap"
  }, [_c('mt-radio', {
    attrs: {
      "options": _vm.listBillSceneLink
    },
    model: {
      value: (_vm.currentCode2),
      callback: function($$v) {
        _vm.currentCode2 = $$v
      },
      expression: "currentCode2"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('div', {
    staticClass: "unSure",
    on: {
      "click": function($event) {
        _vm.showPop2 = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "sure",
    on: {
      "click": _vm.save2
    }
  }, [_vm._v(_vm._s(_vm.$t('determine')) + "\n      ")])])]), _vm._v(" "), _c('mt-popup', {
    staticClass: "selectShift select-wrap",
    staticStyle: {
      "width": "96%",
      "z-index": "3000"
    },
    attrs: {
      "popup-transition": "popup-fade"
    },
    model: {
      value: (_vm.showPopRoom),
      callback: function($$v) {
        _vm.showPopRoom = $$v
      },
      expression: "showPopRoom"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('fangTXQ_changeRoomTitle')))]), _vm._v(" "), _c('div', {
    staticClass: "room-list-wrap"
  }, _vm._l((_vm.roomList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "room-item",
      class: {
        'active': (item.id == _vm.currentSelectRoomItem.id)
      },
      on: {
        "click": function($event) {
          return _vm.chooseChangeRoom(item)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.code) + "\n        ")])
  }), 0), _vm._v(" "), (!_vm.isJingJiang) ? _c('div', {
    staticClass: "room-list-wrap"
  }, [_c('div', {
    staticClass: "title",
    staticStyle: {
      "padding-bottom": "10px",
      "font-size": "15px"
    }
  }, [_vm._v("换房理由")]), _vm._v(" "), _vm._l((_vm.rmchgReasonList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "room-item",
      class: {
        'active': (item.code == _vm.chooseRmchgReasonItem.code)
      },
      on: {
        "click": function($event) {
          return _vm.chooseChangeReason(item)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.descript) + "\n      ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('div', {
    staticClass: "unSure",
    on: {
      "click": _vm.closeChangeRoom
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "sure",
    on: {
      "click": _vm.confirmChangeRoom
    }
  }, [_vm._v(_vm._s(_vm.$t('determine')) + "\n      ")])])]), _vm._v(" "), _c('mt-popup', {
    staticClass: "selectShift select-wrap",
    staticStyle: {
      "width": "96%",
      "z-index": "2000"
    },
    attrs: {
      "popup-transition": "popup-fade"
    },
    model: {
      value: (_vm.showPopRoomType),
      callback: function($$v) {
        _vm.showPopRoomType = $$v
      },
      expression: "showPopRoomType"
    }
  }, [_c('h2', [_vm._v("请选择换房房型")]), _vm._v(" "), _c('div', {
    staticClass: "room-list-wrap"
  }, _vm._l((_vm.roomTypeList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "room-item",
      class: {
        'active': (
          (_vm.currentSelectRoomTypeItem.rmtype && (item.rmtype == _vm.currentSelectRoomTypeItem.rmtype)) ||
          (_vm.currentSelectRoomTypeItem.code && (item.code == _vm.currentSelectRoomTypeItem.code)))
      },
      staticStyle: {
        "text-align": "left"
      },
      on: {
        "click": function($event) {
          return _vm.chooseChangeRoomType(item)
        }
      }
    }, [(_vm.isJingJiang) ? [_c('span', {
      staticClass: "rmtype-font"
    }, [_vm._v(_vm._s(item.rmtype))]), _vm._v(" (" + _vm._s(item.rate1) + "元)\n        ")] : _c('span', {
      staticClass: "rmtype-font"
    }, [_vm._v(_vm._s(item.name))])], 2)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('div', {
    staticClass: "unSure",
    on: {
      "click": _vm.closeChangeRoomType
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "sure",
    on: {
      "click": _vm.confirmChangeRoomType
    }
  }, [_vm._v(_vm._s(_vm.$t('determine')) + "\n      ")])])]), _vm._v(" "), (_vm.showEditPriceModal) ? _c('div', {
    staticClass: "edit-price-modal"
  }, [_c('div', {
    staticClass: "edit-price-modal-container"
  }, [_c('div', {
    staticClass: "edit-price-title"
  }, [_vm._v("\n        修改房价\n        "), _c('i', {
    staticClass: "iconfont icon-cuowu",
    on: {
      "click": _vm.closeEditPrice
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "edit-top-nav"
  }, [_c('span', {
    staticClass: "edit-top-item edit-date"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_date')))]), _vm._v(" "), _c('span', {
    staticClass: "edit-top-item origin-price"
  }, [_vm._v("协议价")]), _vm._v(" "), _c('span', {
    staticClass: "edit-top-item edit-price"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_rate')))]), _vm._v(" "), _c('span', {
    staticClass: "edit-top-item edit-reason"
  }, [_vm._v(_vm._s(_vm.$t('book_reason')))])]), _vm._v(" "), _c('div', {
    staticClass: "edit-price-body"
  }, _vm._l((_vm.currentRsvRates), function(item, index) {
    return _c('div', {
      key: "everyDayRate" + item.rsv_date,
      staticClass: "edit-price-item",
      class: {
        active: _vm.currentLi == index
      },
      on: {
        "click": function($event) {
          return _vm.setCurrentLi(index)
        }
      }
    }, [_c('span', {
      staticClass: "edit-date",
      class: {
        firday: new Date(item.rsv_date).getDay() == 6 || new Date(item.rsv_date).getDay() == 0
      },
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v("\n            " + _vm._s(_vm._f("dateMD")(item.rsv_date)) + "\n            "), _c('br'), _vm._v("\n            " + _vm._s(_vm._f("week")(item.rsv_date)) + "\n          ")]), _vm._v(" "), _c('span', {
      staticClass: "origin-price",
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(item.realPrice))]), _vm._v(" "), _c('div', {
      staticClass: "edit-price"
    }, [_c('span', [_vm._v("￥\n              "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.realRate),
        expression: "item.realRate"
      }],
      staticClass: "spe-input",
      attrs: {
        "type": "number",
        "disabled": !item.dscResaon
      },
      domProps: {
        "value": (item.realRate)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "realRate", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "edit-reason"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.dscResaon),
        expression: "item.dscResaon"
      }],
      staticClass: "options",
      staticStyle: {
        "width": "98%"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "dscResaon", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.reasonList), function(item2, index2) {
      return _c('option', {
        key: index2,
        domProps: {
          "value": item2.code
        }
      }, [_vm._v(_vm._s(item2.descript) + "(" + _vm._s(item2.disc1 * 100) + "%)\n              ")])
    }), 0)])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "edit-price-footer"
  }, [_c('div', {
    staticClass: "edit-price-btn price-cancel-btn",
    on: {
      "click": _vm.syncPrice
    }
  }, [_vm._v(_vm._s(_vm.$t('book_sync')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "edit-price-btn",
    on: {
      "click": _vm.confirmEditPrice
    }
  }, [_vm._v(_vm._s(_vm.$t('determine')) + "\n        ")])])])]) : _vm._e(), _vm._v(" "), _c('form-qr-code-modal', {
    ref: "formQrCodeModal",
    on: {
      "emitFormQrCode": _vm.emitFormQrCode
    }
  }), _vm._v(" "), _c('qrcode-modal', {
    ref: "qrCodeModal"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-4af66858","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/page/fangTXQ/fangTXQ.vue
// module id = 1783
// module chunks = 107